module.exports = __webpack_public_path__ + "img/1.78d376eb.svg";